/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const MAX_FEATURE_VISIT_COUNT = 3;
